// Визуальные метаданные раздела: эмодзи вкусов, цвета уровней, ключи категорий.
// Эмодзи декоративные (имя вкуса всегда показывается рядом), поэтому для редких
// вкусов допущены ближайшие аналоги и повторы внутри одной группы.

import type { FlavorLevel } from './flavorLevels'

export const FLAVOR_EMOJI: Record<string, string> = {
  shokolad: '🍫',
  'belyy-shokolad': '🤍',
  kofe: '☕',
  arahis: '🥜',
  bazilik: '🌿',
  korica: '🍂',
  gvozdika: '✨',
  'muskatnyy-oreh': '🌰',
  anis: '✳️',
  'semena-koriandra': '🌾',
  shafran: '🌸',
  kardamon: '✨',
  morkov: '🥕',
  'tykva-batternat': '🎃',
  kashtany: '🌰',
  'greckiy-oreh': '🌰',
  funduk: '🌰',
  mindal: '🌰',
  vishnya: '🍒',
  arbuz: '🍉',
  vinograd: '🍇',
  reven: '🌱',
  klubnika: '🍓',
  ananas: '🍍',
  yabloko: '🍎',
  grusha: '🍐',
  tomaty: '🍅',
  banan: '🍌',
  dynya: '🍈',
  abrikos: '🍑',
  persik: '🍑',
  kokos: '🥥',
  mango: '🥭',
  apelsin: '🍊',
  greypfrut: '🍊',
  laym: '🍋',
  limon: '🍋',
  imbir: '🫚',
  svekla: '🍠',
  rozmarin: '🌿',
  shalfey: '🍃',
  mozhzhevelnik: '🌲',
  timyan: '🌿',
  myata: '🍃',
  'chernaya-smorodina': '🫐',
  ezhevika: '🫐',
  chernika: '🫐',
  malina: '🍓',
  inzhir: '🍇',
  roza: '🌹',
  vanil: '🌼',
  chili: '🌶️',
  'slivochnyy-syr-maskarpone': '🧀',
}

export const getFlavorEmoji = (slug: string): string =>
  FLAVOR_EMOJI[slug] ?? '🍰'

/** Цвета уровней: основной (заливка активного) и мягкий (фон сегмента/чипа). */
export const LEVEL_COLORS: Record<
  FlavorLevel | 'none',
  { main: string; soft: string; text: string }
> = {
  classic: { main: '#57B279', soft: '#E4F3E9', text: '#2E7D4F' },
  interesting: { main: '#E3AD3B', soft: '#FAF0D9', text: '#9C7017' },
  bold: { main: '#E0716D', soft: '#FAE6E5', text: '#B03E3A' },
  none: { main: '#A9BCCB', soft: '#EDF2F6', text: '#5E7387' },
}

export const getLevelColors = (level: FlavorLevel | null) =>
  LEVEL_COLORS[level ?? 'none']

/** Ключи категорий для CSS-модификаторов плиток. */
export const CATEGORY_KEYS: Record<string, string> = {
  'Вкус жареного': 'roasted',
  'Пряный вкус': 'spicy',
  'Древесный вкус': 'woody',
  'Вкус свежих фруктов': 'fresh',
  'Сливочно-фруктовый вкус': 'creamy',
  'Цитрусовый вкус': 'citrus',
  'Травяной и лесной вкус': 'herbal',
  'Цветочно-фруктовый вкус': 'floral',
}

export const getCategoryKey = (category: string): string =>
  CATEGORY_KEYS[category] ?? 'fresh'

/**
 * Цвет точки-«pointer» рядом с названием категории (по макету раздел
 * использует пастельные метки на каждую вкусовую группу).
 */
export const CATEGORY_COLORS: Record<string, string> = {
  'Вкус жареного': '#c99a6b',
  'Пряный вкус': '#e0a15a',
  'Древесный вкус': '#d6aa68',
  'Вкус свежих фруктов': '#f6a5a0',
  'Сливочно-фруктовый вкус': '#fad74d',
  'Цитрусовый вкус': '#f0f377',
  'Травяной и лесной вкус': '#9fce8f',
  'Цветочно-фруктовый вкус': '#f29cd1',
}

export const getCategoryColor = (category: string): string =>
  CATEGORY_COLORS[category] ?? '#c9d4dc'

/**
 * Короткая подпись категории для тегов на карточках и в hero-блоке
 * (в макете вместо «Вкус свежих фруктов» — «Фруктовый» и т.п.).
 */
export const CATEGORY_SHORT: Record<string, string> = {
  'Вкус жареного': 'Жареный',
  'Пряный вкус': 'Пряный',
  'Древесный вкус': 'Древесный',
  'Вкус свежих фруктов': 'Свежие фрукты',
  'Сливочно-фруктовый вкус': 'Сливочно-фруктовый',
  'Цитрусовый вкус': 'Цитрусовый',
  'Травяной и лесной вкус': 'Травяной и лесной',
  'Цветочно-фруктовый вкус': 'Цветочно-фруктовый',
}

export const getCategoryShort = (category: string): string =>
  CATEGORY_SHORT[category] ?? category
